import { sanitize } from "dompurify";
import React, { useEffect, useState } from "react";
import "./PrivacyPolicy.scss";
const PrivacyPolicy = ({setTitle}) => {
  const [html, setHTML] = useState({ __html: "<span></span>" });

  useEffect(() => {
    setTitle("Privacy Policy");
    fetch("Privacy Policy.html").then(async (res) => {
      const result = await res.text();
      setHTML({ __html: sanitize(result, { WHOLE_DOCUMENT: true }) });
    });
  }, []);
  return (
    <div className="privacy-policy">
      <div dangerouslySetInnerHTML={html}></div>
    </div>
  );
};

export default PrivacyPolicy;
